import {
  Folder,
  BasicFolderData,
  CreateFolderType,
  SourceEntityToMoveType
} from "../components/types";

// Simple state update objects for modals and UI controls
export const ModalState = {
  showRenameModal: { showRenameModal: true },
  hideRenameModal: { showRenameModal: false },
  showDeleteModal: { showDeleteModal: true },
  hideDeleteModal: { showDeleteModal: false },
  showMovePopup: { showMovePopup: true },
  hideMovePopup: { showMovePopup: false },
  showCreateFolderModal: { showCreateFolderModal: true },
  showCreateEventModal: { showCreateEventModal: true },
  hideCreateEventModal: {
    showCreateEventModal: false,
    isHeaderEventCreation: false
  },
  hideHeaderDropdown: { showHeaderCreateDropdown: false }
};

export const createClearSelection = () => ({
  selectedMediaId: new Set()
});

// Factory functions for state updates that need parameters
export const setFolderActions = (folder: Folder | BasicFolderData) => ({
  selectedFolderActions: folder
});

export const setEntityToMove = (entity: SourceEntityToMoveType) => ({
  sourceEntityToMove: entity
});

export const setFolderType = (type: CreateFolderType) => ({
  createFolderType: type
});
